class ErrorTone {
    tone = new Audio("/audio/errorTone.mp3");
    _isPlaying = false;
    constructor() {
        this.tone.onplay = () => {
            this._isPlaying = true;
        };
        this.tone.onended = () => {
            this._isPlaying = false;
        };
        this.tone.onpause = () => {
            this._isPlaying = false;
        };
    }
    get isPlaying() {
        return this._isPlaying;
    }
    get volume() {
        return this.tone.volume;
    }
    set volume(volume) {
        this.tone.volume = volume;
    }
    increaseVolume(amount = 0.2) {
        this.volume = Math.min(1, this.volume + amount);
    }
    decreaseVolume(amount = 0.2) {
        this.volume = Math.max(0, this.volume - amount);
    }
    play() {
        this.tone.currentTime = 0;
        void this.tone.play();
    }
    tryPlay() {
        if (this._isPlaying) {
            return;
        }
        this.play();
    }
    stop() {
        this.tone.pause();
        this.tone.currentTime = 0;
    }
}
export const errorTone = new ErrorTone();
//# sourceMappingURL=errorTone.js.map